import LangProvider from "./context/LangProvider";
import { Navbar, Footer, ScrollToTop } from "./components";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {
  Home,
  ContactUs,
  Services,
  Partners,
  About,
  FAQ,
  Error,
} from "./pages";
const App = () => {
  return (
    <LangProvider>
      <Router>
        <ScrollToTop />
        <Navbar />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/services">
            <Services />
          </Route>
          <Route exact path="/partners">
            <Partners />
          </Route>
          <Route exact path="/about">
            <About />
          </Route>
          <Route exact path="/faq">
            <FAQ />
          </Route>
          <Route exact path="/error">
            <Error />
          </Route>
          <Route exact path="/contact-us">
            <ContactUs />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </LangProvider>
  );
};

export default App;
